import React from 'react';
import { styled } from 'styled-components';
import { classic } from '~/themes';
//import { classic } from '~/themes/classic';

type IProps = {
  children: React.ReactNode;
  onClick?: () => void;
};

type TProps = IProps;

export function WrapperRound({ children, onClick }: TProps) {
  return <Container onClick={onClick}>{children}</Container>;
}

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  border-radius: 57.778px;
  cursor: pointer;
  border: 2.222px solid #fff;
  background: ${classic.token?.colorWhite || '#fff'};
  box-shadow:
    0px -4.444px 4.444px 0px rgba(0, 0, 0, 0.25) inset,
    0px 1.111px 3.333px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  pointer-events: auto;
  transition: all 0.3s linear;
  width: 65px;
  height: 65px;
  flex-shrink: 0;
  position: relative;
  img {
  }

  @media screen and (max-height: 800px) {
    width: 58px;
    height: 58px;
  }
  @media screen and (max-width: 450px) {
    width: 44px;
    height: 44px;
    min-width: 44px;
  }

  @media screen and (max-height: 450px) {
    width: 44px;
    height: 44px;
    min-width: 44px;
  }

  &:focus {
    transform: scale(1.1);
  }

  &:hover {
    transform: scale(1.1);
  }
`;

// classic.token?.colorPrimary
/*
@media screen and (max-width: 300px) {
    @media screen and (max-width: 415px) {
    padding: calc(0.5rem + 6px) 5px 10px 5px;
  }
  @media screen and (min-height: 800px) {
    padding: calc(0.7rem + 10px) 24px;
  }
  }
*/
